export const defaultPosLocationField = [
  "name",
  "language",
  "staff",
  "createdAt",
  "action",
];

export const defaultPosStaffField = [
  "name",
  "email",
  "phone",
  "pin",
  "location",
  "createdAt",
  "action",
];

export const DEFAULT_POS_LOCATION_SORT_KEYS = ["name", "language", "staff", "createdAt"];
export const DEFAULT_POS_STAFF_SORT_KEYS = ["name", "email", "phone", "pin", "location", "createdAt"];